import { serviceUrlKeys } from "../utils/reduxMiddleware/extractServiceBaseUrls";

// This map is for mapping query names to FBI service base urls.
export default {
  // Local requests.
  complexFacetSearch: serviceUrlKeys.fbiLocal,
  complexSearchWithPagination: serviceUrlKeys.fbiLocal,
  complexSuggest: serviceUrlKeys.fbiLocal,
  complexSearchWithPaginationWorkAccess: serviceUrlKeys.fbiLocal,
  getDashboardRecommendationSource: serviceUrlKeys.fbiLocal,
  getDashboardRecommendationSourceByIsbn: serviceUrlKeys.fbiLocal,
  getDashboardRecommendations: serviceUrlKeys.fbiLocal,
  getMaterial: serviceUrlKeys.fbiLocal,
  getRelatedWorks: serviceUrlKeys.fbiLocal,
  intelligentFacets: serviceUrlKeys.fbiLocal,
  recommendFromFaust: serviceUrlKeys.fbiLocal,
  searchFacet: serviceUrlKeys.fbiLocal,
  searchWithPagination: serviceUrlKeys.fbiLocal,
  suggestionsFromQueryString: serviceUrlKeys.fbiLocal,
  // Global requests.
  getManifestationViaBestRepresentationByFaust: serviceUrlKeys.fbiGlobal,
  getManifestationViaMaterialByFaust: serviceUrlKeys.fbiGlobal,
  getMaterialGlobally: serviceUrlKeys.fbiGlobal,
  getRetriever: serviceUrlKeys.fbiGlobal,
  getReviewManifestations: serviceUrlKeys.fbiGlobal,
  getSmallWork: serviceUrlKeys.fbiGlobal,
  openOrder: serviceUrlKeys.fbiGlobal,
  // All other requests.
  default: serviceUrlKeys.fbi
} as const;
